import { render, staticRenderFns } from "./FollowUpAdd.vue?vue&type=template&id=5630d7d3&"
import script from "./FollowUpAdd.vue?vue&type=script&lang=js&"
export * from "./FollowUpAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports